// pp-restock-pref.js — Toggle de "Recordatorios de Recompra" en el área de cliente.
//
// Lee el estado (enabled) del App Proxy /apps/crm/customer-restock-pref y lo
// prende/apaga con POST {enabled}. Preferencia a nivel EMPRESA (cualquier
// miembro la cambia). Si el cliente no pertenece a una empresa (found:false),
// oculta la card con gracia. Default ON. NO manda correos — solo captura la
// preferencia que el cron de recompra respeta.
//
// La card puede estar en varias páginas (recompra, configuración, home de
// cuenta): este script maneja TODAS las instancias [data-pp-restock-pref] y las
// mantiene sincronizadas.

(function () {
  'use strict';

  var ENDPOINT = '/apps/crm/customer-restock-pref';
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-pp-restock-pref]'));
  if (!roots.length) return;

  // Skeletons gemelos (reservan el espacio de la card desde el paint). Se ocultan
  // en cuanto resuelve la lectura — muestre o no la card real — para que no quede
  // un hueco ni brinque el layout.
  var skels = Array.prototype.slice.call(document.querySelectorAll('[data-pp-restock-pref-skeleton]'));
  function hideSkeletons() { skels.forEach(function (s) { s.hidden = true; }); }

  // En el editor del theme no hay sesión de cliente → no consultar.
  if (window.Shopify && window.Shopify.designMode) return;

  function tOf(root, key, fallback) {
    return root.getAttribute('data-t-' + key) || fallback;
  }

  function reflect(root, enabled) {
    var input = root.querySelector('[data-pp-restock-pref-input]');
    var stateEl = root.querySelector('[data-pp-restock-pref-state]');
    if (input) input.checked = !!enabled;
    if (stateEl) {
      stateEl.textContent = enabled
        ? tOf(root, 'on', 'Activados')
        : tOf(root, 'off', 'Desactivados');
    }
  }

  function reflectAll(enabled) { roots.forEach(function (r) { reflect(r, enabled); }); }
  function setDisabled(v) {
    roots.forEach(function (r) {
      var i = r.querySelector('[data-pp-restock-pref-input]');
      if (i) i.disabled = v;
    });
  }
  function setStateAll(txt) {
    roots.forEach(function (r) {
      var s = r.querySelector('[data-pp-restock-pref-state]');
      if (s) s.textContent = txt;
    });
  }

  function bind(root) {
    var input = root.querySelector('[data-pp-restock-pref-input]');
    if (!input || input.dataset.ppBound) return;
    input.dataset.ppBound = '1';
    input.addEventListener('change', function () {
      var desired = input.checked;
      setDisabled(true);
      fetch(ENDPOINT, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ enabled: desired })
      })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (d) {
          setDisabled(false);
          if (!d || d.ok !== true) {
            reflectAll(!desired);
            setStateAll(tOf(root, 'error', 'No pudimos guardar el cambio. Intenta de nuevo.'));
            return;
          }
          reflectAll(d.enabled !== false);
        })
        .catch(function () {
          setDisabled(false);
          reflectAll(!desired);
          setStateAll(tOf(root, 'error', 'No pudimos guardar el cambio. Intenta de nuevo.'));
        });
    });
  }

  // Estado inicial: una sola lectura compartida por todas las instancias.
  // Usa PPAccount (prefetch + dedup) si existe; si no, fetch directo.
  var read = (window.PPAccount)
    ? window.PPAccount.get('customer-restock-pref')
    : fetch(ENDPOINT, { method: 'GET', credentials: 'same-origin' })
        .then(function (r) { return r.json().catch(function () { return null; }); });

  read.then(function (d) {
    hideSkeletons();
    roots.forEach(function (root) {
      // Sin empresa → la preferencia B2B no aplica: oculta la card.
      if (!d || d.found === false) { root.hidden = true; return; }
      root.hidden = false;
      reflect(root, d.enabled !== false); // default ON
      bind(root);
    });
  }).catch(function () {
    // Error transitorio: deja las cards en su estado por defecto (ON) y activas.
    hideSkeletons();
    roots.forEach(function (root) { root.hidden = false; reflect(root, true); bind(root); });
  });
})();
